import { AxiosInstance } from 'axios';

import { axios } from '../../../../api/axios-instance';
import { giftsEndpoings } from '../../../../constants';
import { DateFilter } from '../../../../enum/date-filter.enum';
import { GiftsResponse } from '../../../general/schemas/gift.schema';

class GiftsApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  getGifts = async (userId: number, order: DateFilter): Promise<GiftsResponse> =>
    this.#requestInstance.get(giftsEndpoings.giftsId(userId), {
      params: {
        order,
      },
    });
}

export const giftsApi = new GiftsApi(axios);
